import createRoute          from '@widesk-ui/tools/createRoute';
import PartnershipTypeModel from '@models/website/PartnershipTypeModel';

const route = createRoute.splitView(
	'configuration/partnership_types',
	'website',
	'PartnershipTypeSplitView',
	PartnershipTypeModel.localize('plural'),
);
export default route;
